import { render, staticRenderFns } from "./GChatFileMessageContainer.vue?vue&type=template&id=38193e2d&"
import script from "./GChatFileMessageContainer.vue?vue&type=script&lang=ts&"
export * from "./GChatFileMessageContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports